export default "__VITE_ASSET__1TEPET9x__"